// Standard OpenStreetMap credit, required wherever OSM tiles are shown.
// https://www.openstreetmap.org/copyright
export const OSM_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noreferrer">OpenStreetMap</a> contributors';
